var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconTime = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-time_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 161177",
  fill: "none",
  d: "M0 0h64v64H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31341",
  clipPath: "url(#icon-time_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38733",
  d: "M54.857 32A22.857 22.857 0 1132 9.143 22.857 22.857 0 0154.857 32",
  fill: "#f9a23a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38734",
  d: "M50.233 32a18.234 18.234 0 11-18.232-18.234A18.233 18.233 0 0150.234 32",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38735",
  d: "M32.001 13.682a18.448 18.448 0 013.691.372 18.217 18.217 0 016.55 2.757 18.374 18.374 0 016.633 8.064 18.226 18.226 0 011.067 3.439 18.494 18.494 0 010 7.383 18.219 18.219 0 01-2.756 6.55 18.371 18.371 0 01-8.055 6.628 18.224 18.224 0 01-3.438 1.067 18.494 18.494 0 01-7.383 0 18.22 18.22 0 01-6.55-2.756 18.373 18.373 0 01-6.637-8.059 18.225 18.225 0 01-1.068-3.439 18.492 18.492 0 010-7.383 18.218 18.218 0 012.757-6.55 18.375 18.375 0 018.063-6.633 18.227 18.227 0 013.439-1.068 18.449 18.449 0 013.687-.372zm0 36.467a18.283 18.283 0 003.658-.369 18.049 18.049 0 006.489-2.731 18.2 18.2 0 006.575-7.985 18.06 18.06 0 001.057-3.407 18.326 18.326 0 000-7.315 18.05 18.05 0 00-2.731-6.489 18.2 18.2 0 00-7.984-6.578 18.056 18.056 0 00-3.406-1.058 18.322 18.322 0 00-7.315 0 18.05 18.05 0 00-6.49 2.731 18.205 18.205 0 00-6.579 7.989 18.055 18.055 0 00-1.058 3.406 18.322 18.322 0 000 7.315 18.048 18.048 0 002.731 6.49 18.2 18.2 0 007.986 6.576 18.061 18.061 0 003.407 1.057 18.284 18.284 0 003.66.368z",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38736",
  d: "M26.236 36.742a.978.978 0 01-.536-1.8l5.3-3.47v-9.711a.978.978 0 011.956 0v10.24a.978.978 0 01-.443.818l-5.747 3.759a.974.974 0 01-.53.164z",
  fill: "#283c8c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38737",
  d: "M32.001 12.788A19.212 19.212 0 1112.788 32a19.233 19.233 0 0119.213-19.212zm0 36.467A17.256 17.256 0 1014.745 32a17.275 17.275 0 0017.256 17.258z",
  fill: "#283c8c"
}))));
export default __webpack_public_path__ + "static/icon-time.515c222dc885d2ddd07027c887748f82.svg";
export { SvgIconTime as ReactComponent };